import OthersLogoImg from "@/assets/others.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const OthersLogo = (props: Props) => (
  <LogoImage imgSrc={OthersLogoImg} alt="Others Logo" size="navbar" {...props} />
);
